angular.module('mustache', []).factory('mustache', [
    '$window',
    function ($window) {
        return $window.Mustache;
    },
]);
